/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SexEnum = {
    Male: 'Male',
    Female: 'Female',
    Other: 'Other'
} as const;
export type SexEnum = typeof SexEnum[keyof typeof SexEnum];


export function instanceOfSexEnum(value: any): boolean {
    return Object.values(SexEnum).includes(value);
}

export function SexEnumFromJSON(json: any): SexEnum {
    return SexEnumFromJSONTyped(json, false);
}

export function SexEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SexEnum {
    return json as SexEnum;
}

export function SexEnumToJSON(value?: SexEnum | null): any {
    return value as any;
}

